module.exports = __webpack_public_path__ + "img/nav-assets.1c2159be.svg";